<template>
<div>
  <b-container class="marginal">
    <b-card
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <b-card-body>
        <h1>
          {{$ml.get('successpayment')}}
        </h1>
        <p>{{$ml.get('paymentsuccessp1')}}</p>
        
      </b-card-body>
    </b-card>
  </b-container>
</div>
</template>

<script>
import PaymentService from '@/services/payment.service';
let paymentService = new PaymentService();

export default {
  name: "PluginPaymentSuccess",
  components: {

  },
  data() {
    return {

    }
  },
  mounted() {
    let session_id = this.$route.query['session_id'];
    if (session_id) {
      this.postPaymentSuccess(session_id);
    }
  },
  methods: {
    postPaymentSuccess(session_id) {
      paymentService.postPaymentSuccess(session_id, this.$auth.token()).then(() => {
        console.log("Paiement success");
        this.$auth.validateWithServer();
      }).catch(err => {
        console.log("Erreur à la validation")
      })
    }
  }

};
</script>